var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47656 1.26562H15.3047C15.6328 1.26562 15.8984 1 15.8984 0.671875C15.8984 0.335938 15.6328 0.078125 15.3047 0.078125H1.47656C1.14844 0.078125 0.882812 0.34375 0.882812 0.671875C0.882812 1 1.14844 1.26562 1.47656 1.26562ZM1.47656 4.52344H15.3047C15.6328 4.52344 15.8984 4.25781 15.8984 3.92969C15.8984 3.59375 15.6328 3.32812 15.3047 3.32812H1.47656C1.14844 3.32812 0.882812 3.59375 0.882812 3.92969C0.882812 4.25781 1.14844 4.52344 1.47656 4.52344ZM1.47656 7.78125H15.3047C15.6328 7.78125 15.8984 7.51562 15.8984 7.17969C15.8984 6.85156 15.6328 6.58594 15.3047 6.58594H1.47656C1.14844 6.58594 0.882812 6.85156 0.882812 7.17969C0.882812 7.51562 1.14844 7.78125 1.47656 7.78125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.50e270c63ce7e3febae1c2b0bfb16eee.svg";
export { ForwardRef as ReactComponent };